import { LogCityChart } from './LogCityChart'
import { withLogCityChart } from './withLogCityChart'

const ConnectedLogCityChart = withLogCityChart(LogCityChart)

export { ConnectedLogCityChart as LogCityChart }
